<div class="validate-session-container">
  <div class="loading-content">
    <div class="spinner"></div>
    <h3>{{ type === 'login' ? 'Validando sesión...' : 'Cierre de sesión segura' }}</h3>
    <p>Por favor espera mientras {{ type === 'login' ? 'verificamos tu información' : 'cerramos tu sesión' }} </p>
  </div>
</div>
